<template>
    <div class="animated fadeIn staticPageInner bgV2 pb-19">
        <b-row class="heig-frame-tab">
            <b-col md="12" class="pt-20">
                <div class="p-3 bg-white boxShadow box-shadow-none mt--1 no-boder">
                    <div class="boxShadow noBorder mb-0">
                        <div class="padding-13 pt-4 heig-frame-child">
                            <gofix-button class="m-3" label="Button 1" @click="clickCallback(1)" :loading="loading"></gofix-button>
                            <gofix-button class="m-3" label="Button 2" @click="clickCallback(2)" :loading="loading" outline></gofix-button>
                            <gofix-button class="m-3" label="Button 3" @click="clickCallback(3)" :loading="loading" disabled></gofix-button>
                            <gofix-button class="m-3" label="Button 4" @click="clickCallback(4)" :loading="loading" disabled outline></gofix-button>
                            <hr/>
                            <gofix-button class="m-3" label="Add Priority" @click="clickCallback(1)" >
                                <template #gofix:button:beforeLabel><i class="fa fa-address-card fa-lg"></i></template>
                            </gofix-button>
                            <gofix-button class="m-3" label="Add Priority" @click="clickCallback(2)" outline>
                                <template #gofix:button:beforeLabel><i class="fa fa-address-card fa-lg"></i></template>
                            </gofix-button>
                            <gofix-button class="m-3" label="Add Priority" @click="clickCallback(3)" disabled>
                                <template #gofix:button:beforeLabel><i class="fa fa-address-card fa-lg"></i></template>
                            </gofix-button>
                            <gofix-button class="m-3" label="Add Priority" @click="clickCallback(4)" disabled outline>
                                <template #gofix:button:beforeLabel><i class="fa fa-address-card fa-lg"></i></template>
                            </gofix-button>
                            <hr/>
                            <gofix-button class="m-3" label="Related Supplier Contracts (4)" @click="clickCallback(1)" :loading="loading" noBorder></gofix-button>
                            <gofix-button class="m-3" label="Related Supplier Contracts (4)" @click="clickCallback(1)" :loading="loading" noBorder dark></gofix-button>
                            <gofix-button class="m-3" label="Related Supplier Contracts (4)" @click="clickCallback(3)" :loading="loading" noBorder disabled></gofix-button>
                            <hr/>
                            <gofix-button class="m-3" label="Related Supplier Contracts (4)" @click="clickCallback(1)" :loading="loading" noBorder fontNormal></gofix-button>
                            <gofix-button class="m-3" label="Related Supplier Contracts (4)" @click="clickCallback(1)" :loading="loading" noBorder fontNormal dark></gofix-button>
                            <gofix-button class="m-3" label="Related Supplier Contracts (4)" @click="clickCallback(3)" :loading="loading" noBorder fontNormal disabled></gofix-button>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'button-demo',
        components: {

        },
        data() {
            return {
                loading: false
            }
        },
        computed: {},
        watch: {},
        created() {

        },
        methods: {
            clickCallback(i){
                this.loading =true;
            }
        }
    }
</script>
